import React, { Suspense } from 'react';
import { Route, Redirect } from 'react-router-dom';
import {LocalStore} from "../../utils/LocalStore";
import CheckPermission from '../../utils/CheckPermission';
import ConstVar from '../../utils/staticClass/ConstVar';

export default class PrivateRoute extends React.Component{

    render(){
        const { component: Component, RouteKey, location, permissions, ...rest } = this.props;

        /**
         * Sometimes we need to force a React Route to re-render when the
         * search params (query) in the url changes. React Router does not
         * do this automatically if you are on the same page when the query
         * changes. By passing the `RouteKey`ro the `ScrollToTopRoute` and
         * setting it to true, we are passing the combination of pathname and
         * search params as a unique key to the component and that is a enough
         * and clear trigger for the component to re-render without side effects
         */
        const Key = RouteKey ? location.pathname + location.search : null;
        // let sessionAuthorities = LocalStore.getInstance().read(ConstVar.loginSession);

        // if(!sessionAuthorities) return <Redirect to={{ pathname: '/dang-nhap', state: { from: location } }} />;
        
        return(
            <Route exact={true} {...rest} key={Key} render={props => {
                return (
                    LocalStore.getInstance().read(ConstVar.loginSession)
                        ? 
                            CheckPermission.isAllowed(permissions) 
                            ? <Suspense fallback={(<div>Loading ...</div>)} > <Component {...props} /></Suspense>
                            : <h1>Bạn không có quyền</h1>
                        : <Redirect to={{ pathname: '/dang-nhap', state: { from: location } }} />
                        
                )
            }} />
        );
    }
}